// extracted by mini-css-extract-plugin
export default {"list":"AvailabilityBadges__list--n0OAs"};